import { render, staticRenderFns } from "./EditInput.vue?vue&type=template&id=4fb6134e&"
import script from "./EditInput.vue?vue&type=script&lang=js&"
export * from "./EditInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports